
import { useState, useEffect ,useRef} from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaDownload } from "react-icons/fa6";
import logo from '../../../assets/star.jpg';
import mammoth from "mammoth";
import "react-quill/dist/quill.snow.css";
import { useLoading } from '../../../context/LoadingContext';
import { MdDeleteForever } from "react-icons/md";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import html2canvas from 'html2canvas';
import { useLocation } from "react-router-dom";
import { FaTimes } from 'react-icons/fa';
import socket from "../../../socket";

function AMC({ adminData, branchID  ,companyID , financialYear}) {
   const invoiceRef = useRef();
  const searchInputRef = useRef(null);

    const location = useLocation();
       const mode = location.state?.mode;
    const partyId = location.state?.partyId;
    const editData = location.state?.data;

       const navData = location.state;
       const showFormFromNav = navData?.showForm;
   const partyData = navData?.partyData;

  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);

    const [offset, setOffset] = useState(0);
               const limit = 20;
               const [hasMore, setHasMore] = useState(true);
               const [fromDate, setFromDate] = useState();
               const [toDate, setToDate] = useState();
               const [isLocked, setIsLocked] = useState(false);
               const [fy, setFy] = useState([]);
           
               const [financialRange, setFinancialRange] = useState({
                   from_date: '',
                   to_date: ''
               });

  useEffect(() => {
            if (mode === "edit" && editData) {
                handleEdit(editData);   
            }
        }, [editData, mode]);

  
   useEffect(() => {
      if (showFormFromNav) setShowForm(true);
  
      if (partyData) {
        setFormItems((prev) => ({
          ...prev,
          party: partyData.partyid,
          partyName:partyData.party,
          // cust_enq: partyData.partyid,
          description: partyData.site,
          contact_no: partyData.contact_no,
              ref_doc: partyData.ref_doc ,
              partyAddress:partyData.site
        }));
      }
    }, [partyData, showFormFromNav]);
  


  const getCurrentDateTime = () => {
    const now = new Date();

    const istOffset = 5.5 * 60;
    const localOffset = now.getTimezoneOffset();
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const year = istTime.getFullYear();
    const month = String(istTime.getMonth() + 1).padStart(2, "0");
    const day = String(istTime.getDate()).padStart(2, "0");
    const hours = String(istTime.getHours()).padStart(2, "0");
    const minutes = String(istTime.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [search, setSearch] = useState("");
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [partyOptions, setPartyOptions] = useState([]);
  const [detail, setDetail] = useState([]);
  const [user, setUser] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [selectedParty, setSelectedParty] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [quotation, setQuotation] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isInitialEditLoad, setIsInitialEditLoad] = useState(false);
  const [branchDetail, setBranchDetail] = useState([])
  const [refDocs, setRefDocs] = useState([]);
  const [allSaleInvoices, setAllSaleInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const [fetchWarranty, setFetchWaranty] = useState([]);
  const [grandTotalState, setGrandTotalState] = useState(0);
  const [pmsSchedule, setPmsSchedule] = useState([]);
  const [chargeMaster, setChargeMaster] = useState([]);
  const [chargeOptions, setChargeOptions] = useState([]);
  const [amcQuotation, setAmcQuotation] = useState([]);
  const [serialsByItem, setSerialsByItem] = useState({});
  const [serialError, setSerialError] = useState({});
  const [callList, setCallList] = useState([]);
 const [refDocsCall, setRefDocsCall] = useState([]);
 const [selectedCall, setSelectedCall] = useState(null);
  const [amc, setAmc] = useState([]);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
   const[company,setCompany] = useState([]);
const [refDocType, setRefDocType] = useState("");

  const [formItems, setFormItems] = useState({
    ref_doc: '',
    type_acc: '',
    party: '',
    sale_person: '',
    technician: '',
    created_date: getCurrentDateTime(),
    start_date: '',
    end_date: '',
    grand_totaol: "",
    sub_totlal: '',
    totla_gst: '',
    frequency: null,
    amc_type: null,
    remark: '',
    additionalDetails: [],
  })

  const [files, setFiles] = useState({
    file: null,

  })

  
                    useEffect(() => {
                      if (showPartyModal) {
                        setTimeout(() => {
                          searchInputRef.current?.focus();
                        }, 100);
                      }
                    }, [showPartyModal]);
  
  const [formData, setFormData] = useState([]);

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  useEffect(() => {
    if (!branchDetail?.code) return;
  
    socket.on("new-amc", (data) => {
  
  
      if (data.branch === branchDetail.code) {
        showToast(data.message, "info");
      }
    });
  
    return () => socket.off("new-call");
  }, [branchDetail]);


  const frequencyOptions = [
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "half-yearly", label: "Half Yearly" },
    { value: "bi-monthly", label: "Bi Monthly" },
    { value: "four-monthly", label: "Four Monthly" },
  ];


  const [typeOptions, setTypeOptions] = useState([
    "Comprehensive",
    "Non-Comprehensive",
  ]);


  const amcTypeSelectOptions = [
    ...typeOptions.map(type => ({
      value: type,
      label: type
    })),
    {
      value: "__add_new_type__",
      label: "➕ Add New Type"
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFrequencyChange = (option) => {
    setFormItems(prev => ({
      ...prev,
      frequency: option.value
    }));
  };

  const handleTypeSelect = (value) => {
    if (value === "__add_new_type__") {
      setShowTypeModal(true);
      return;
    }
    let remarkText = "";
    if (value === "Comprehensive") {
      remarkText = "This service includes comprehensive warranty coverage.";
    } else if (value === "Non-Comprehensive") {
      remarkText = "This service includes non-comprehensive warranty coverage.";
    }
    setFormItems(prev => ({
      ...prev,
      amc_type: value,
      remark: remarkText
    }));
  };

  const handleAddClick = () => {
    setShowForm(true);
  }


  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    const fieldName = e.target.name;


    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes → MB
      if (fileSizeInMB > 2) {
        setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
        return;
      }
      setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
    }

    if (fieldName === "customLetter") {
      if (!file.name.endsWith(".docx")) {
        setToast("Please upload a .docx file for Custom Letter", "danger");
        return;
      }

      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.convertToHtml({ arrayBuffer });
    }
  };

  const handleSelectChange = (e) => {
    const id = e.target.value;
    if (!id) return;
    const selectedItem = items.find((i) => i.id == id);
    if (!selectedItem) return;
    setFormData((prev) => [
      ...prev,
      {
        id: selectedItem.id,
        name: selectedItem.name,
        qty: 0,
        rate: selectedItem.rate || 0,
        gst: "",
        amount: "",
        tax: selectedItem.tax || "",
        sr_no: '',
        install: ''
      },
    ]);
  };


  const filtered = partyOptions.filter(
    (p) =>
      p.label.toLowerCase().includes(search.toLowerCase()) ||
      (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
      (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
  );



  const handleFormItemChange = (index, field, value) => {
    const updated = [...formData];
    updated[index] = {
      ...updated[index],
      [field]: value
    };

    const qty = parseFloat(updated[index].qty) || 0;
    const rate = parseFloat(updated[index].rate) || 0;
    const tax = parseFloat(updated[index].tax) || 0;

    const baseAmount = qty * rate;
    const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
    const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));

    updated[index].baseAmount = baseAmount;
    updated[index].taxAmount = taxAmount;
    updated[index].amount = totalAmount;

    // if ((field === "id" || field === "qty") && updated[index].id && qty > 0) {
    //   fetchSerials(updated[index].id, qty);
    // }

    if (updated[index].id && qty > 0) {
  fetchSerials(updated[index].id, qty);
}

    setFormData(updated);

    // Always recalc subtotals and GST
    const subTotal = updated.reduce((sum, item) => sum + (item.baseAmount || 0), 0);
    const totalGst = updated.reduce((sum, item) => sum + (item.taxAmount || 0), 0);

    const chargesTotal = (formItems?.additionalDetails ?? []).reduce(
      (sum, item) => sum + (Number(item.value2) || 0),
      0
    );

    let grandTotalCalc = 0;

    if (isEditMode) {

      grandTotalCalc = parseFloat(formItems.total) || 0;
    } else {
  
      grandTotalCalc =
        updated.reduce((sum, item) => sum + (Number(item.amount) || 0), 0) +
        chargesTotal;
    }

    setSubTotal(subTotal.toFixed(2));
    setTotalTax(totalGst.toFixed(2));
    setGrandTotal(grandTotalCalc.toFixed(2));
  };


  const handleDeleteItem = (indexToRemove) => {
    const newItems = formData.filter((_, idx) => idx !== indexToRemove);
    const currentExtra = formItems.additionalDetails || [];
    recalcTotals(newItems, currentExtra);
    setFormData(newItems);
  };



  const handleSelectDoc = (selectedOption) => {
    if (!selectedOption) return;
    setSelectedDoc(selectedOption);
 setRefDocType("quotation"); 

    const selectedAmc = amcQuotation.find(a => a.ref_doc === selectedOption.value );

    if (!selectedAmc) {
      console.warn("AMC Quotation not found for:", selectedOption.value);
      return;
    }

    // Parse additional charges
    const additionalDetails = selectedAmc.additional_charges
      ? JSON.parse(selectedAmc.additional_charges).map(c => ({
        ...c,
        value2: Number(c.value2) || 0
      }))
      : [];

    // Parse items
    let itemsData = [];
    try {
      itemsData = JSON.parse(selectedAmc.items || "[]").map(item => {
        const qty = Number(item.qty) || 0;
        const rate = Number(item.rate) || 0;
        const tax = Number(item.tax) || 0;
        const install_in = item.install;
        const baseAmount = qty * rate;
        const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
        const amount = parseFloat((baseAmount + taxAmount).toFixed(2));
        return { ...item, qty, rate, tax, baseAmount, taxAmount, amount,install_in };
      });
    } catch (err) {
      console.error("Error parsing items JSON:", err);
    }

    const subTotal = itemsData.reduce((sum, i) => sum + i.baseAmount, 0);
    const totalGst = itemsData.reduce((sum, i) => sum + i.taxAmount, 0);
    const chargesTotal = additionalDetails.reduce(
      (sum, c) => (c.type?.toLowerCase() === "discount" ? sum - c.value2 : sum + c.value2),
      0
    );
    const grandTotal = subTotal + totalGst + chargesTotal;

    setFormItems(prev => ({
      ...prev,
  
      ref_doc: selectedOption.value,
      ref_doc_sq: selectedOption.ref_doc_sq || null,
      cust_enq: selectedAmc.cust_enq,
      quotation_date: selectedAmc.quotation_date,
      sale_person: selectedAmc.sale_person,
      technician:selectedAmc.technician,
      description:selectedAmc.description,
      remark: selectedAmc.remark,
      start_date:selectedAmc.start_date,
      end_date:selectedAmc.end_date,
      amc_type:selectedAmc.amc_type,
      frequency:selectedAmc.frequency,
      created_date:selectedAmc.created_date,
      file: selectedAmc.file,
      additionalDetails,
      grandTotal
    }));

    setFormData(itemsData);

     itemsData.forEach(item => {
        if (item.id && item.qty > 0) {
          fetchSerials(item.id, item.qty);
        }
      });
    setSubTotal(subTotal);
    setTotalTax(totalGst);
    setGrandTotal(grandTotal);
  };

  


const handleSelectDocCall = (selectedOption) => {
  if (!selectedOption) return;

  setSelectedCall(selectedOption);
   setRefDocType("call");

  const selectedAmc = callList.find(
    a => String(a.ref_doc) === String(selectedOption.value)
  );

  if (!selectedAmc) {
    console.warn("Call not found for:", selectedOption.value);
    return;
  }

  // Parse additional charges
  const additionalDetails = selectedAmc.additional_charges
    ? JSON.parse(selectedAmc.additional_charges).map(c => ({
        ...c,
        value2: Number(c.value2) || 0
      }))
    : [];

  // Parse items
  let itemsData = [];
  try {
    itemsData = JSON.parse(selectedAmc.items || "[]").map(item => {
      const qty = Number(item.qty) || 0;
      const rate = Number(item.rate) || 0;
      const tax = Number(item.tax) || 0;

      const baseAmount = qty * rate;
      const taxAmount = +(baseAmount * tax / 100).toFixed(2);
      const amount = +(baseAmount + taxAmount).toFixed(2);

      return {
        ...item,
        qty,
        rate,
        tax,
        baseAmount,
        taxAmount,
        amount,
        install_in: item.install
      };
    });
  } catch (err) {
    console.error("Error parsing items JSON:", err);
  }

  const subTotal = itemsData.reduce((s, i) => s + i.baseAmount, 0);
  const totalGst = itemsData.reduce((s, i) => s + i.taxAmount, 0);
  const chargesTotal = additionalDetails.reduce(
    (sum, c) =>
      c.type?.toLowerCase() === "discount"
        ? sum - c.value2
        : sum + c.value2,
    0
  );

  const grandTotal = subTotal + totalGst + chargesTotal;

  setFormItems(prev => ({
    ...prev,
    ref_doc: selectedOption.value,
    cust_enq: selectedAmc.cust_enq,
    quotation_date: selectedAmc.quotation_date,
    sale_person: selectedAmc.sale_person,
    technician: selectedAmc.technician,
    description: selectedAmc.description,
    remark: selectedAmc.remark,
    start_date: selectedAmc.start_date,
    end_date: selectedAmc.end_date,
    amc_type: selectedAmc.amc_type,
    frequency: selectedAmc.frequency,
    created_date: selectedAmc.created_date,
    file: selectedAmc.file,
    additionalDetails,
    grandTotal
  }));

  setFormData(itemsData);
   itemsData.forEach(item => {
        if (item.id && item.qty > 0) {
          fetchSerials(item.id, item.qty);
        }
      });
  setSubTotal(subTotal);
  setTotalTax(totalGst);
  setGrandTotal(grandTotal);
};



  const recalcTotals = (items = [], extraRows = []) => {

    const updatedItems = Array.isArray(items) ? items : [];
    const updatedExtra = Array.isArray(extraRows) ? extraRows : [];


    const subTotal = updatedItems.reduce(
      (sum, item) => sum + (Number(item.baseAmount) || 0),
      0
    );

    const totalGst = updatedItems.reduce(
      (sum, item) => sum + (Number(item.taxAmount) || 0),
      0
    );

    // Calculate extra charges / discounts
    const chargesTotal = updatedExtra.reduce((sum, item) => {
      const value = Number(item.value2) || 0;
      return item.type?.toLowerCase() === "discount" ? sum - value : sum + value;
    }, 0);


    const grandTotal = subTotal + totalGst + chargesTotal;

    // Update state
    setSubTotal(subTotal.toFixed(2));
    setTotalTax(totalGst.toFixed(2));
    setGrandTotal(grandTotal.toFixed(2));
  };

  const handleGstChange = (value, index) => {
    const updated = [...formData];

    // Update tax
    updated[index].tax = value;

    // Convert tax string like "18%" to number 18
    const taxPercent = parseFloat(value) || 0;

    // Recalculate amounts
    const qty = parseFloat(updated[index].qty) || 0;
    const rate = parseFloat(updated[index].rate) || 0;

    const baseAmount = qty * rate;
    const gstAmount = parseFloat(((baseAmount * taxPercent) / 100).toFixed(2));
    const amount = parseFloat((baseAmount + gstAmount).toFixed(2));


    updated[index].baseAmount = baseAmount;
    updated[index].taxAmount = gstAmount;
    updated[index].amount = amount;

    // Update state
    setFormData(updated);

    // Recalculate totals for the table (including extra rows if any)
    recalcTotals(updated, formItems?.additionalDetails || []);
  };

  const addRow = () => {
    setFormItems(prev => ({
      ...prev,
      additionalDetails: [
        ...(prev.additionalDetails || []),
        { id: Date.now(), type: "SGT" }
      ]
    }));
  };


  const deleteRow = (indexToRemove) => {
    const newExtra = (formItems.additionalDetails || []).filter(
      (_, idx) => idx !== indexToRemove
    );
    setFormItems((prev) => ({ ...prev, additionalDetails: newExtra }));
    recalcTotals(formData, newExtra);
  };


  const updateRowField = (id, field, value) => {
    setFormItems(prev => {
      const updated = (prev.additionalDetails || []).map(row => {
        if (row.id === id) {
          const newRow = { ...row, [field]: value };

          // Recalculate value2 if value1 changes
          if (field === "value1") {
            const numeric = parseFloat(value) || 0;

            // Use current subTotal to calculate value2
            newRow.value2 = ((numeric * (formData.reduce((sum, item) => sum + (item.baseAmount || 0), 0))) / 100).toFixed(2);
          }
          return newRow;
        }
        return row;
      });

      const newFormItems = { ...prev, additionalDetails: updated };
      recalcTotals(formData, updated);
      return newFormItems;
    });
  };


  useEffect(() => {
    if (isEditMode) {
      setTimeout(() => setIsInitialEditLoad(false), 0);
    }
  }, [formData]);

  const fecthDetail = async () => {
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      const items = resInventory.data.result || [];
      setItems(items);

   
    } catch (error) {
      console.log(error)
    }
  };


  const fetchSerials = async (inventoryId, qty) => {
    if (!inventoryId) return;

    try {
      const res = await axios.get(
        "https://api.skyguard.group/api/fetch-inventory-serials",
        { params: { inventory_id: inventoryId } }
      );

      const flattened = Array.isArray(res.data[0]) ? res.data.flat() : res.data;
      const unsoldSerials = Array.from(
        new Map(flattened.map(s => [s.id, s])).values()
      ).filter(s => !s.sold_on || s.sold_on === 0);

      setSerialsByItem(prev => ({
        ...prev,
        [inventoryId]: unsoldSerials
      }));


    

      if (qty > unsoldSerials.length) {
        setSerialError(prev => ({
          ...prev,
          [inventoryId]: `Not enough serial numbers .`
        }));
      } else {
        setSerialError(prev => ({
          ...prev,
          [inventoryId]: null
        }));
      }
    } catch (err) {
      console.error("Error fetching serials:", err);
    }
  };


  const fetchPartyDetail = async () => {
    try {
      const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");

      const options = resParty.data.map((p) => ({
        value: p.id,
        label: p.name,
        phone: p.phone,
        address: p.address,
        phone: p.phone || "",
        mobile: p.mobile || "",
        phone_two: p.phone_two || "",
        phone_three: p.phone_three || "",

      }));

      const data = resParty.data;

      setDetail(data);

      setPartyOptions(options);

    } catch (error) {
      console.log(error);
    }
  };

  const fectEmphDetail = async () => {
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
         const filtered = (resEmployee.data.result || []).filter(
      emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
    );

    setUser(filtered);


    } catch (error) {
      console.log(error)
    }
  };

   const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };
  const fetchYearDetail = async () => {
                    setLoading(true);
                    try {
                        const branchCode = await fetchBranchDetail();
                        const res = await axios.get(
                            `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                        );
                        const yearData = res.data;
                        setFy(yearData);
                        setIsLocked(yearData.is_locked === 1);
                        setFinancialRange({
                            from_date: yearData.from_date,
                            to_date: yearData.to_date
                        });
            
                        await fetchAmc(
                            yearData.from_date,
                            yearData.to_date,
                            branchCode,
            
                        );
                    } catch (error) {
                        console.log(error);
                    } finally {
                        setLoading(false);
                    }
                };
  

  const fetchChargeDetail = async () => {
    setLoading(true)
    try {
      const response = await axios.get('https://api.skyguard.group/api/fetch-master-charge');
      setChargeMaster(response.data);
      const options = response.data.map((item) => ({
        value: item.charge_name,
        label: item.charge_name
      }));

      setChargeOptions(options);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fetchAmcQuotaion = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-amc-quotation');
      setAmcQuotation(res.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchComplaints = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-complaint");
      setCallList(res.data);
      // console.log(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const fetchAmc = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {
    setLoading(true)

    
     if (!branchCode) {
            console.log("Branch code missing");
            return;
        }


    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-amc',

         {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
      );
      // setAmc(res.data)
       const result = res.data;
            if (newOffset === 0) {
                setAmc(result);
                setHasMore(true);
            }

            else {
                setAmc(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }
   
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }


        const fetchCompany = async () => {
          setLoading(true)
        try {
          const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
          setCompany(res.data);
    
        } catch (error) {
          console.log(error)
        } finally {
         setLoading(false);
            }
      };
    

  useEffect(() => {
    fetchAmcQuotaion();
    fecthDetail();
    fetchPartyDetail();
    fectEmphDetail();
    fetchSerials();
    fetchBranchDetail();
    fetchYearDetail();
    fetchChargeDetail();
    fetchComplaints();

    fetchCompany();
  }, []);




  const handleUpdate = async (e) => {
    e.preventDefault();

    const sendData = new FormData();
    const safe = (v) => (v === undefined || v === null ? "" : v);

    // Basic fields
      sendData.append("ref_doc", formItems.ref_doc);
      sendData.append("ref_doc_type", refDocType);


    sendData.append("type_acc", "amc");
    sendData.append("party", formItems.party);
    sendData.append(
      "created_date",
      formItems.created_date || new Date().toISOString().split("T")[0]
    );
    sendData.append("sale_person", formItems.sale_person);
    sendData.append("technician", formItems.technician);

    sendData.append(
      "start_date",
      formItems.start_date
        ? formItems.start_date.replace("T", " ")
        : ""
    );

    sendData.append(
      "end_date",
      formItems.end_date
        ? formItems.end_date.replace("T", " ")
        : ""
    );
    sendData.append("grand_total", grandTotal);
    sendData.append("total_gst", totalTax);
    sendData.append("sub_total", subTotal);
    sendData.append("frequency", formItems.frequency);
    sendData.append("amc_type", safe(formItems.amc_type));
    sendData.append("remark", safe(formItems.remark));
    sendData.append('branch', branchDetail.code)
    if (files.file) sendData.append("file", files.file);


    // Items table
    sendData.append(
      "items",
      JSON.stringify(
        (formData || []).map((item) => {
          const qty = parseFloat(item.qty) || 0;
          const rate = parseFloat(item.rate) || 0;
          const tax = parseFloat(item.tax) || 0;
          const baseAmount = qty * rate;
          const gstAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
          const amount = parseFloat((baseAmount + gstAmount).toFixed(2));

          return {
            id: item.id || null,
            name: item.name,
            qty,
            rate,
            tax,
            gst_amount: gstAmount,
            base_amount: baseAmount,
            amount,
            sr_no: item.sr_no || "",
            install: item.install || "",
          };
        })
      )
    );

    // Additional Charges (safe)
    sendData.append(
      "additional_charges",
      JSON.stringify(
        (formItems.additionalDetails || []).map((row) => ({
          id: row.id || null,
          type: row.type,
          value1: Number(row.value1) || 0,
          value2: Number(row.value2) || 0,
        }))
      )
    );


    const startDate = formItems.start_date;
    const endDate = formItems.end_date;
    const frequency = formItems.frequency;

    if (startDate && endDate && frequency) {
      const schedule = generatePMSchedule(startDate, endDate, frequency);
      setPmsSchedule(schedule);
      sendData.append("pms_schedule", JSON.stringify(schedule));
    }
    try {
      let res;

      if (isEditMode && editingCompanyId) {
        sendData.append("edit_by", adminData.user.id);

        res = await axios.put(
          `https://api.skyguard.group/api/update-amc/${editingCompanyId}`,
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("AMC  Updated Successfully!", "success");
      // fetchAmc();
      } else {
        sendData.append("added_by", adminData.user.id);

        res = await axios.post(
          "https://api.skyguard.group/api/add-amc",
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("AMC  Added Successfully!", "success");
     fetchAmc(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
      }
      const startDate = formItems.start_date;
      const endDate = formItems.end_date;
      const frequency = formItems.frequency;

      if (startDate && endDate && frequency) {
        const schedule = generatePMSchedule(startDate, endDate, frequency);
        setPmsSchedule(schedule);
      }

      resetForm();
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      showToast(
        isEditMode ? "Failed to update!" : "Failed to create!",
        "danger"
      );
    }
  };

  const resetForm = () => {
    setFormItems({
      party: "",
      cust_enq: "",
      quotation_date: "",
      sale_person: "",
      technician: "",
      grand_total: "",
      total_gst: "",
      sub_total: "",
      remark: "",
      description: "",
      ref_doc: "",
      type_acc: "",
      subject: '',
      customLetter: null,
    });

    setFormData([]);
    setSelectedDoc(null);
    setSelectedCall(null);
    setSelectedParty(null);
    setSubTotal("0.00");
    setTotalTax("0.00");
    setGrandTotal("0.00");
    setFiles({});
    setShowForm(false);

    setPmsSchedule([]);
    setRefDocs([]);
    setRefDocsCall([]);
  };

  useEffect(() => {
    if (isEditMode && formItems.ref_doc === null && refDocs.length && editingCompanyId) {

      const selected = refDocs.find(
        opt => String(opt.value) === String(formItems.ref_doc)
      );

      if (selected) {
        setFormItems(prev => ({
          ...prev,
          ref_doc: selected
        }));
      }
    }
  }, [refDocs, isEditMode]);



  useEffect(() => {
    if (isEditMode) {
      setGrandTotalState(parseFloat(formItems.total) || 0);
    } else {
      const total = formData.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );
      setGrandTotalState(total);
    }
    // ⚠ Only recalc when formData changes in add mode
  }, [isEditMode, formItems.total, ...(isEditMode ? [] : [formData])]);



  const handleEdit = (form) => {

    let parsedItems = [];
    try {
      parsedItems = JSON.parse(form.items || "[]");
    } catch (err) {
      console.log("Invalid JSON for items:", err);
    }
  parsedItems = parsedItems.map((item) => {
      const qty = parseFloat(item.qty) || 0;
      const rate = parseFloat(item.rate) || 0;
      const tax = parseFloat(item.tax) || 0;

      const baseAmount = qty * rate;
      const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
      const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));

      return {
        ...item,
        baseAmount,
        taxAmount,
        amount: totalAmount,
      };
    });

    setFormData(parsedItems);

     let parsedAdditionalDetails = [];
    try {
      parsedAdditionalDetails = JSON.parse(form.additional_charges || "[]");
    } catch (err) {
      console.log("Invalid JSON for additional_charges:", err);
    }

    const subTotal = parsedItems.reduce(
      (sum, item) => sum + (item.baseAmount || 0),
      0
    );

    const totalGst = parsedItems.reduce(
      (sum, item) => sum + (item.taxAmount || 0),
      0
    );

    const chargesTotal = parsedAdditionalDetails.reduce((sum, item) => {
      const value = Number(item.value2) || 0;
      return item.type?.toLowerCase() === "discount"
        ? sum - value
        : sum + value;
    }, 0);

    const grandTotal = subTotal + totalGst + chargesTotal;


    setSubTotal(subTotal.toFixed(2));
    setTotalTax(totalGst.toFixed(2));
    setGrandTotal(grandTotal.toFixed(2));


    let parsedPms = [];
    try {
      parsedPms = JSON.parse(form.pms_schedule || "[]");
    } catch (err) {
      console.log("Invalid JSON for pms_schedule:", err);
    }
    setPmsSchedule(parsedPms);



    /* ---------------- AMC REF DOC ---------------- */
  const filteredAmc = amcQuotation.filter(
    q => String(q.party) === String(form.party)
  );

  const amcOptions = filteredAmc.map(q => ({
    value: String(q.ref_doc),
    label: q.inv_no
      ? `AQ: ${q.inv_no}`
      : `AQ: ${q.ref_doc}`
  }));

  setRefDocs(amcOptions);

  const selectedAmcDoc = amcOptions.find(
    d => String(d.value) === String(form.ref_doc)
  );

  /* ---------------- CALL REF DOC ---------------- */
  const filteredCalls = callList.filter(
    c => String(c.partyid) === String(form.party)
  );

  const callOptions = filteredCalls.map(c => ({
    value: String(c.ref_doc),
    label: `CMP: ${c.ref_doc}`
  }));

  setRefDocsCall(callOptions);

  const selectedCallDoc = callOptions.find(
    d => String(d.value) === String(form.ref_doc)
  );

  /* ---------------- DECIDE WHICH ONE TO SHOW ---------------- */
  if (selectedAmcDoc) {
    setSelectedDoc(selectedAmcDoc);
    setSelectedCall(null);
  } else if (selectedCallDoc) {
    setSelectedCall(selectedCallDoc);
    setSelectedDoc(null);
  } else {
    setSelectedDoc(null);
    setSelectedCall(null);
  }

    setFormItems({
      id: form.id || "",
      // party: form.party || "",
      // partyName: form.party_name || "",
      //     partyAddress: form.party_address || "",


    //      party:form.party  || partyData.partyid || "",
    // partyName: partyData.party || form.party_name || "",
    // partyAddress: partyData.site || form.party_address || "",
    // contact_no: partyData.contact_no || form.contact_no || "",

 party: form.party || partyData?.partyid || "",
  partyName: partyData?.party || form.party_name || "",
  partyAddress: partyData?.site || form.party_address || "",
  contact_no: partyData?.contact_no || form.contact_no || "",


      ref_doc: form.ref_doc || '',
      sale_person: form.sale_person || "",
      technician: form.technician || "",
      created_date: form.created_date || "",
      start_date: form.start_date || '',
      end_date: form.end_date || '',
      total: form.total || "",
      frequency: form.frequency || "",
      amc_type: form.amc_type || "",
      remark: form.remark || "",
       branch: form.branch || "",
       ref_doc_type:form.ref_doc_type || "",
    });

    //fetch sr_no in edit mode
    parsedItems.forEach(it => {
      if (it.id && it.qty > 0) fetchSerials(it.id, it.qty);
    });

    setFiles({ file: form.file || null });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


  const generatePMSchedule = (startDate, endDate, frequency) => {
    const schedule = [];
    let current = new Date(startDate);
    const end = new Date(endDate);
    let pmsNo = 1;

    const addMonths = (date, months) => {
      const d = new Date(date);
      d.setMonth(d.getMonth() + months);
      return d;
    };

    let increment = 1;
    switch (frequency) {
      case "monthly":
        increment = 1;
        break;
      case "bi-monthly":
        increment = 2;
        break;
      case "quarterly":
        increment = 3;
        break;
      case "four-monthly":
        increment = 4;
        break;
      case "half-yearly":
        increment = 6;
        break;
      default:
        increment = 1;
    }

    while (current <= end) {
      schedule.push({
        pmsNo: pmsNo++,
        dueDate: current.toISOString().split("T")[0],
        completionDate: ""
      });
      current = addMonths(current, increment);
    }

    return schedule;
  };

  const getSerialNumbers = (inventory_id, qty) => {
    if (!inventory_id || !qty) return [];

    const list = serialsByItem[inventory_id] || [];
    return list.slice(0, qty).map(s => s.sr_no);
  };


  const filteredData = amc.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

 const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

    const handleViewQuotation = (quotation) => {
      if (!quotation) {
        console.warn("No Enquiry passed to handleViewQuotation()");
        return;
      }
  
      setSelectedQuotation(quotation);
      setShowDownloadModal(true);
    };
  
  
  const handleDownloadInvoice = () => {
    const input = invoiceRef.current;
    if (!input) return;
  
    const noPrintEls = input.querySelectorAll(".no-print");
  
    // 🔥 hide using visibility (NOT display)
    noPrintEls.forEach(el => {
      el.style.visibility = "hidden";
    });
  
    html2canvas(input, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true
    })
      .then(canvas => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "pt", "a4");
  
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
  
        const imgProps = pdf.getImageProperties(imgData);
        const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
  
        let heightLeft = imgHeight;
        let position = 0;
  
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
  
        while (heightLeft > 0) {
          position -= pdfHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
          heightLeft -= pdfHeight;
        }
  
        pdf.save(`invoice_order_${selectedQuotation.id}.pdf`);
      })
      .finally(() => {
      
        noPrintEls.forEach(el => {
          el.style.visibility = "visible";
        });
      });
  };


const usedRefDocSet = new Set(
  amc
    .filter(q => q.ref_doc) 
    .map(q => String(q.ref_doc))
);

const usedCallRefDocSet = new Set(
  amc
    .filter(q => q.ref_doc)
    .map(q => String(q.ref_doc))
);

  const handlePrint = () => {
  const printContents = document.getElementById("invoice-print-area");

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
      <head>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
        <style>
          body { margin: 10px; }
        </style>
      </head>
      <body></body>
    </html>
  `);

  printWindow.document.close();

  // ✅ Clone exact node (keeps structure better)
  const clonedContent = printContents.cloneNode(true);
  printWindow.document.body.appendChild(clonedContent);

  printWindow.focus();
  printWindow.print();
  printWindow.close();
};


   const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        fetchAmc(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };


  return (
    <>
      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <h3 className='my-3 fw-bold fs-5 golos'>AMC</h3>
          <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
            <div class="col-12 col-md-4">
              <input
                type="text"
                class="form-control"
                id="searchInput"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-end">
              <button className='btn btn-success' onClick={handleAddClick} >
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>
          {showForm && (
            <form onSubmit={handleUpdate}>


              <div className='card p-3 my-3 shadow-sm bg-white border'>
                <div className='row'>

                  <div className='col-12'>
                                                                {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`AMCI/${formItems.id}/${formItems.branch}`}
    </span>
  </div>
)}
                    <div className='row g-3'>

                      <div className="col-12 col-md-4">
                        <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Choose Party..."
                          value={formItems.partyName || ""}
                          readOnly
                          onClick={() => setShowPartyModal(true)}
                          required
                        />

                        <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title>Search Party</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form.Control
                              type="text"
                              placeholder="Search by name, phone, or address"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                                 ref={searchInputRef}
                            />
                            <div className="table-responsive mt-3">
                              <Table striped bordered hover className="mt-3">
                                <thead>
                                  <tr>
                                        <th>Action</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                
                                  </tr>
                                </thead>
                                <tbody>
                                  {filtered.map((p) => (
                                    <tr key={p.value}>
                                        <td className="text-center" style={{ width: "80px" }}>

                                        <Button
                                          variant="primary"
                                          size="sm"

onClick={() => {
  setFormItems(prev => ({
    ...prev,
    party: p.value,
    partyName: p.label,
    partyAddress: p.address,
    ref_doc: null,
    ref_doc_sq: null
  }));

  // -------- AMC FILTER --------
  const filteredAmc = amcQuotation.filter(
    q =>
      String(q.party) === String(p.value) &&
      q.ref_doc &&
      !usedRefDocSet.has(String(q.ref_doc))
  );

  setRefDocs(
    filteredAmc.map(q => ({
      value: q.ref_doc,
      label: `AQ: ${q.ref_doc}`
    }))
  );

  // -------- CALL FILTER --------
  const filteredCall = callList.filter(
    q =>
      String(q.partyid) === String(p.value) &&
      q.ref_doc &&
      !usedCallRefDocSet.has(String(q.ref_doc))
  );

  setRefDocsCall(
    filteredCall.map(q => ({
      value: String(q.ref_doc),
      label: `CMP: ${q.ref_doc}`
    }))
  );

  setSelectedDoc(null);
  setSelectedCall(null);
  setShowPartyModal(false);
}}

                                        >
                                          Select
                                        </Button>

                                      </td>
                                      <td>{p.label}</td>
                                      <td>{p.phone}</td>
                                      <td style={{ maxWidth: "300px", whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {(p.address || "").length > 50 ? `${(p.address || "").slice(0, 50)}...` : (p.address || "NA")}
                                      </td>
                                    
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </Modal.Body>
                        </Modal>
                      </div >

                      <div className='col-12 col-md-4'>
                        <label>Party Address </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Choose Party..."
                          value={formItems.partyAddress || ""}
                          readOnly
                          onClick={() => setShowPartyModal(true)}
                          required
                        />
                      </div>


                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Ref Doc Quoattaion.</label>
                        <Select
                          placeholder="Choose Ref Doc..."
                          options={refDocs}
                          value={selectedDoc}
                          onChange={handleSelectDoc}
                          isDisabled={isEditMode}
                             isClearable
                        />
                      </div>
                        
                          <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Ref Doc Call</label>
                        <Select
                          placeholder="Choose Ref Doc..."
                          options={refDocsCall}
                         value={selectedCall}
                          onChange={handleSelectDocCall}
                          isClearable
                             isDisabled={isEditMode}
                        />
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium"> Date </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="created_date"
                          value={
                            formItems.created_date
                          }
                          onChange={handleChange}
                        />
                      </div>


                      <div className="col-12 col-sm-12 col-md-4">
                        <label className="form-label fw-medium">Sale Person</label>
                        <Select
                          options={user.map((t) => ({
                            value: t.id,
                            label: `${t.first} ${t.last} (${t.emp_id})`,
                          }))}


                          value={
                            user
                              .map((t) => ({
                                value: t.id,
                                label: `${t.first} ${t.last} (${t.emp_id})`,
                              }))
                              .find((opt) => opt.value == formItems.sale_person) || null
                          }
                          onChange={(e) =>
                            handleChange({ target: { name: "sale_person", value: e.value } })
                          }
                          className="w-100"
                          menuPlacement="auto"
                        />

                      </div>

                      <div className="col-12 col-sm-12 col-md-4">
                        <label className="form-label fw-medium">Technician</label>

                        <Select
                          options={user.map((t) => ({
                            value: t.id,
                            label: `${t.first} ${t.last} (${t.emp_id})`,
                          }))}


                          value={
                            user
                              .map((t) => ({
                                value: t.id,
                                label: `${t.first} ${t.last} (${t.emp_id})`,
                              }))
                              .find((opt) => opt.value == formItems.technician) || null
                          }

                          onChange={(e) =>
                            handleChange({ target: { name: "technician", value: e.value } })
                          }
                          className="w-100"
                          menuPlacement="auto"
                        />


                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Start Date </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="start_date"
                          value={formItems.start_date}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">End Date </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="end_date"
                          value={formItems.end_date}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Items:</label>

                        <Select
                          options={items.map((t) => ({
                            value: t.id,
                            label: `${t.name} (${t.stock})`,
                          }))}

                          value={
                            selectedItemId
                              ? {
                                value: selectedItemId,
                                label:
                                  items.find((i) => i.id === selectedItemId)?.name +
                                  " (" +
                                  items.find((i) => i.id === selectedItemId)?.stock +
                                  ")",
                              }
                              : null
                          }

                          // onChange={(e) =>
                          //   handleSelectChange({
                          //     target: { name: "emp_id", value: e?.value || "" },
                          //   })
                          // }

                         onChange={(e) => {
  if (!e) return;

  const selectedItem = items.find(i => i.id === e.value);

  const newRow = {
    id: selectedItem.id,
    name: selectedItem.name,
    qty: 0,
    rate: selectedItem.rate || 0,
    install: "",
    tax: selectedItem.tax || 0,
    amount: 0,
    baseAmount: 0,
    taxAmount: 0
  };

  setFormData(prev => [...prev, newRow]);
}}



                          className="w-100"
                          menuPlacement="auto"
                        />
                      </div>

                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle">
                        <thead className="table-primary">
                          <tr>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th>Item  Rate</th>
                            <th>Installed In</th>
                            <th>Sr No. </th>
                            <th>Item GST</th>

                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.length === 0 ? (
                            <tr>
                              <td colSpan="6" className="text-center text-muted">
                                Select an item from the dropdown to add here
                              </td>
                            </tr>
                          ) : (
                            formData.map((fi, idx) => (
                              <tr key={idx}>
                                <td><input type="text" className="form-control" value={fi.name} onChange={(e) => handleFormItemChange(idx, "name", e.target.value)} /></td>
                                <td><input type="number" className="form-control" value={fi.qty} onChange={(e) => handleFormItemChange(idx, "qty", e.target.value)} /></td>
                                <td><input type="number" className="form-control" value={fi.rate} onChange={(e) => handleFormItemChange(idx, "rate", e.target.value)} /></td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={fi.install}
                                    onChange={(e) => handleFormItemChange(idx, "install", e.target.value)}
                                  />
                                </td>
                                <td><input type="text" className="form-control"
                                  value={getSerialNumbers(fi.id, fi.qty).join(", ")}
                                  // value={fi.sr_no}
                                  readOnly
                                />
                                  {serialError[fi.id] && (
                                    <small className="text-danger">{serialError[fi.id]}</small>
                                  )}
                                </td>

                                <td>
                                  <select
                                    className="form-control"
                                    value={fi.tax}
                                    onChange={(e) => handleGstChange(e.target.value, idx)}
                                  >

                                    <option value={fi.tax}> {fi.tax} </option>


                                    <option disabled>──────────</option>


                                    <option value="0%">0%</option>
                                    <option value="5%">5%</option>
                                    <option value="12%">12%</option>
                                    <option value="18%">18%</option>
                                    <option value="28%">28%</option>
                                  </select>
                                </td>




                                <td><input type="text" className="form-control" value={fi.amount || ""} readOnly /></td>
                                <td>
                                  <button className="btn btn-danger" onClick={() => handleDeleteItem(idx)}>Delete</button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                        <tfoot>




                          <tr>
                            <td colSpan="5" className="text-end fw-bold">Total GST</td>
                            <td><input type="text" value={totalTax} readOnly className="form-control" /></td>
                            <td className="text-end fw-bold">SUB Total</td>
                            <td><input type="text" value={subTotal} readOnly className="form-control" /></td>
                          </tr>


                          <tr className="text-end fw-bold">
                            <td colSpan="8">
                              <div className="d-flex justify-content-end mb-2">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={addRow}
                                >
                                  + Add Row
                                </button>
                              </div>
                            </td>
                          </tr>


                          {formItems.additionalDetails?.map((row, index) => (
                            <tr key={row.id || index}>
                              <td colSpan="8">
                                <div className="d-flex justify-content-end align-items-center gap-2">
                                  <Select
                                    menuPortalTarget={document.body}

                                    options={chargeOptions}
                                    value={chargeOptions.find(option => option.value === row.type)}
                                    onChange={(selected) => {

                                      const selectedCharge = chargeMaster.find(
                                        (item) => item.charge_name === selected.value
                                      );


                                      updateRowField(row.id, "type", selected.value);


                                      if (selectedCharge) {
                                        updateRowField(row.id, "value1", selectedCharge.charge_mrp);
                                      }
                                    }}
                                    placeholder="Select Charge"
                                    hideSelectedOptions={false}
                                    styles={{ container: (base) => ({ ...base, width: 150 }) }}
                                  />


                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: "120px" }}
                                    value={row.value1 || ""}

                                    onChange={(e) => updateRowField(row.id, "value1", e.target.value)}
                                  />

                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: "120px" }}
                                    value={row.value2 || ""}

                                    onChange={(e) => updateRowField(row.id, "value2", e.target.value)}
                                  />


                                  <button className="btn btn-danger btn-sm" onClick={() => deleteRow(index)}>

                                    <MdDeleteForever size={20} />
                                  </button>
                                </div>
                              </td>
                            </tr>

                          ))}


                          <tr>
                            <td colSpan="7" className="text-end fw-bold">Grand Total</td>
                            <td>
                              <input type="text"
                                value={grandTotal}

                                readOnly className="form-control" />


                            </td>

                          </tr>


                        </tfoot>
                      </table>
                    </div>
                  </div>

                  <div className='col-12 col-md-6 p-3'>
                    <label className='form-label fw-medium'>Attachment</label>
                    <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange} />
                    {isEditMode && files.file && typeof files.file === "string" && (
                      <div className="mt-2">
                        <span>Previous file: </span>
                        <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                      </div>
                    )}
                  </div>


                  <div className='col-12 col-md-6 p-3'>
                    <label>Service Frequency</label>
                    <Select
                      options={frequencyOptions}
                      placeholder="Select frequency"
                      name='frequency'
                      value={frequencyOptions.find(o => o.value === formItems.frequency)}
                      onChange={handleFrequencyChange}
                      isDisabled={isEditMode}
                    />
                  </div>


                  <div className='col-12 col-md-6 p-3'>

                    {pmsSchedule.length > 0 && (
                      <table className='table table-bordered text-center align-middle mt-3'>
                        <thead>
                          <tr className="table-primary">
                            <th>PMS No.</th>
                            <th>Due Date</th>
                            <th>Completion Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pmsSchedule.map((item) => (
                            <tr key={item.pmsNo}>
                              {/* <td>{item.pmsNo}</td> */}
                              <td>{`AMC/${item.pmsNo}/${branchDetail.code}`}</td>
                              <td>{item.dueDate}</td>
                              <td>{item.completionDate}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>


                  <div className='row' >
                    <div className="col-12 col-md-6 p-3">
                      <label>Type</label>
                      <Select
                        options={amcTypeSelectOptions}
                        value={
                          formItems.amc_type
                            ? { value: formItems.amc_type, label: formItems.amc_type }
                            : null
                        }
                        placeholder="Select AMC Type"
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                        }}
                        onChange={(selected) => {
                          if (!selected) {
                            setFormItems(prev => ({
                              ...prev,
                              amc_type: "",
                              remark: ""
                            }));
                            return;
                          }

                          handleTypeSelect(selected.value);
                        }}
                      />
                    </div>


                    {showTypeModal && (
                      <div className="modal show d-block" tabIndex="-1">
                        <div className="modal-dialog">
                          <div className="modal-content">

                            <div className="modal-header">
                              <h5 className="modal-title">Add New Type</h5>
                              <button
                                className="btn-close"
                                onClick={() => setShowTypeModal(false)}
                              />
                            </div>

                            <div className="modal-body">
                              <input
                                type="text"
                                className="form-control"
                                value={newTypeName}
                                onChange={(e) => setNewTypeName(e.target.value)}
                              />
                            </div>

                            <div className="modal-footer">
                              <button
                                className="btn btn-secondary"
                                onClick={() => {
                                  setShowTypeModal(false);
                                  setNewTypeName("");
                                }}
                              >
                                Cancel
                              </button>

                              <button
                                className="btn btn-success"
                                onClick={() => {
                                  if (!newTypeName.trim()) return;

                                  setTypeOptions(prev => [...prev, newTypeName]);

                                  setFormItems(prev => ({
                                    ...prev,
                                    warranty_type: newTypeName,
                                    remark: ""
                                  }));

                                  setNewTypeName("");
                                  setShowTypeModal(false);
                                }}
                              >
                                OK
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>
                    )}

                    <div className='col-12 col-md-6 p-3'>
                      <label className='form-label fw-medium'>Remark</label>
                      <textarea className='form-control w-100' rows="5" name='remark' value={formItems.remark} onChange={handleChange}></textarea>
                    </div>
                  </div>



                  <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                    <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                    <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                  </div>
                </div>
              </div>


            </form>
          )}


          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>
              <thead className='table-info'>
                <tr>
                          <th scope='col' >Action</th>
                  <th scope='col' >Doc No. </th>
                  <th scope='col'>Party Name</th>
                  <th scope='col'>Added By</th>
                  <th scope='col'>Added Date</th>

                  <th scope='col'>Edit By</th>

                  <th scope='col'>Edit Date</th>

          
                </tr>
              </thead>
              <tbody>
                  {filteredData.map((p, i) => (
                                  <tr key={p.id}>
                                         <td>
                
                                      <button
                                        className="btn btn-success"
                
                                        onClick={() => handleEdit(p)}
                                      >
                                        <CiEdit size={20} />
                                      </button>
                                         <button
                                                              className="btn btn-warning mx-1"
                                                              onClick={() => handleViewQuotation(p)}
                                      
                                      
                                                            >
                                                              <FaDownload size={20} />
                                                            </button>
                                    </td>
                               
                                    <td>{`AMCI/${p.id}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>
                
                                    <td>{p.party_name}</td>
                                    <td>{p.added_name} {p.added_name_middle} {p.added_name_last} </td>
                                    <td>{formatDateTime(p.created_date) }  </td>
                                    <td>{p.edit_name} {p.edit_name_middle} {p.edit_name_last} </td>
                                    <td>{formatDateTime(p.edit_date) } </td>
                
                               
                                  </tr>
                                ))}
              </tbody>


            </table>

             {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
          </div>

  {showDownloadModal && selectedQuotation && (() => {
              const parsedItems = selectedQuotation.items
                ? JSON.parse(selectedQuotation.items)
                : [];

              const parsedAdditionalDetails = selectedQuotation.additional_charges
                ? JSON.parse(selectedQuotation.additional_charges)
                : [];


              const headerImageUrl = `https://api.skyguard.group/uploads/${branchDetail.header_img}`;

              return (
                <div
                  className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                  style={{
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 9999,
                  }}
                >

                  <div
                    style={{
                      background: "#fff",
                      width: "90%",
                      maxWidth: "900px",
                      borderRadius: "8px",
                      padding: "20px",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      position: "relative",
                    }}
                  >

                    <button
                      onClick={() => setShowDownloadModal(false)}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        border: "none",
                        background: "transparent",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                    >
                      ✖
                    </button>


         

                    <div id="invoice-print-area" style={{ position: "relative" }}>
                      <img
                        src={headerImageUrl}
                        alt="header"
                         style={{
                                                position: "absolute",
                                                top: "30%",
                                                left: "50%",
                                                width: "350px",
                                                height: "350px",
                                                opacity: "0.2",
                                                transform: "translate(-50%, -50%)",
                                                zIndex: "0",
                                            }}
                      />
                      <div style={{ position: "relative", zIndex: 1 }}>

                  

                      <h3 style={{ textAlign: "center", marginBottom: "5px" }}>AMC Invoice</h3>




                      <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
                        <tbody >
                          <tr >
                            <td style={{ width: "60%", padding: "8px" }} className='text-start'>

                              <table style={{ width: "100%" }} >
                                <tbody>
                                  <tr>{company.name} </tr>
                                  <tr> {company.address} </tr>
                                  <tr>Phone: {company.phone} </tr>
                                  <tr> GSTIN: {company.gst} </tr>
                                  <tr>Email : {company.email} </tr>
                                  <tr>Pan : {company.pan} </tr>
                                </tbody>
                              </table>


                            </td>

                            <td style={{ width: "40%" }} >

                              <table style={{ width: "95%" }} className='text-start'>

                                <tbody >
               
                                  <tr>
                                    <td>Date</td>
                                    <td>{selectedQuotation.created_date}</td>
                                  </tr>
                                  <tr>
                                    <td>Doc No
                                    </td>
                                  <td>{`AMCI/${selectedQuotation.id}/${selectedQuotation.branch}`}</td>
                                  </tr>


                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>


                      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%", padding: "8px" }} className='text-start'>
                              <b>Party Detail:</b><br />
                              <table style={{ width: "100%" }} >
                                <tbody >
                                  <tr>{selectedQuotation.party_name} </tr>
                                  <tr> {selectedQuotation.party_address} </tr>

                                  <tr>{selectedQuotation.party_state} , {selectedQuotation.party_city} </tr>
                                  <tr> {selectedQuotation.party_region}, {selectedQuotation.party_pincode}  </tr>
                                  <tr>Phone: {selectedQuotation.party_phone} </tr>
                                  <tr>  Email: {selectedQuotation.party_email}</tr>
                                  <tr>  GST. :{selectedQuotation.party_gst}  </tr>
                                

                                </tbody>
                              </table>
                            </td>

                          </tr>
                        </tbody>
                      </table>


                      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1" className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead>
                          <tr>
                            <th>Sr No</th>
                            <th>Description of Goods</th>
                            {/* <th>HSN</th> */}
                            <th>Qty</th>
                            <th>SR No</th>
                     
        <th>Rate</th>
     
        <th>Amount</th> 
                          </tr>
                        </thead>

                        <tbody>
                          {parsedItems.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.name}</td>

                              <td>{item.qty}</td>
                              <td>{item.sr_no} </td>
                          
          <td>{item.rate}</td>
       
          <td>{item.amount}</td> 
                            </tr>
                          ))}


     


      {parsedAdditionalDetails.length > 0 && (
  <>
    <tr>
      <td colSpan="5" style={{ textAlign: "left", fontWeight: "bold" }}>
        Additional Charges
      </td>
    </tr>

    {parsedAdditionalDetails.map((row, index) => (
      <tr key={index}>
        <td colSpan="4" style={{ textAlign: "right" }}>
          {row.type}
        </td>
        <td style={{ textAlign: "right" }}>
          {Number(row.value2 || 0).toFixed(2)}
        </td>
      </tr>
    ))}
  </>
)}

      <tr>
        <td colSpan="5" style={{ textAlign: "right" }}><b>Total</b></td>
        <td><b>{selectedQuotation.grand_total}</b></td>
      </tr>
                        </tbody>
                      </table>


                      <div style={{ marginTop: "5px", border: "1px solid #000", padding: "5px" }} className='text-start'>
                        <b>Amount Chargeable (In Words):</b> Rupees Only
                      </div>


                      <table
                        style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}
                        border="1"
                      >
                        <tbody>
                          <tr>

                       
                            <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                              <div style={{ border: "1px solid #000", padding: "8px" }}>
                                <b>Company Bank Details:</b>

                                <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                  <tbody>
                                    <tr>
                                      <td>Bank Name</td>
                                      <td>{company.bank_name} </td>
                                    </tr>
                                    <tr>
                                      <td>Account No</td>
                                      <td>{company.acc_no}  </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC Code</td>
                                      <td>{company.ifsc} </td>
                                    </tr>
                                    <tr>
                                      <td>Branch</td>
                                      <td>{company.branch} </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                            </td>

                          
                            <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                              {/* <div style={{ border: "1px solid #000", padding: "8px" }}>
                                <b>Party Bank Details:</b>

                                <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                  <tbody>
                                    <tr>
                                      <td>Bank Name</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <td>Account No</td>
                                      <td> - </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC Code</td>
                                      <td>- </td>
                                    </tr>
                                    <tr>
                                      <td>Branch</td>
                                      <td>- </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div> */}

                            </td>

                          </tr>
                        </tbody>
                      </table>


                     

                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
  <tbody>
    <tr> 
      <td
        style={{
          width: "100%",  
          padding: "8px",
          verticalAlign: "top",
          textAlign: "right", 
        }}
      >
        <div
          style={{
            border: "1px solid #000",
            height: "160px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            padding: "10px",
          }}
        >
          <b>Authorised Signatory</b>
        </div>
      </td>
    </tr>
  </tbody>
</table>



                      <table className="table table-start">
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: "34%",
                                padding: "8px",
                                verticalAlign: "top", 
                                textAlign: "left",    
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid #000",
                                  height: "160px",
                                  paddingBottom: "10px",
                                  textAlign: "left", // ✅ ensure inner content also left
                                }}
                              >
                                <strong>T & C :</strong>

                              {selectedQuotation.remark
  ?.split(/\d+:-\s*/)
  .filter(Boolean) // remove empty strings from the split
  .map((item, index) => (
    <div key={index} style={{ textAlign: "left" }}>
      {`${index + 1}. ${item.trim()}`}
    </div>
  ))}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>


                    

                    </div>


                    <div
                      className="no-print"
                      style={{ marginTop: "15px", textAlign: "right" }}
                    >
                      <button
                        onClick={handlePrint}
                        style={{
                          marginRight: "10px",
                          padding: "8px 15px",
                          background: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Print
                      </button>

                      <button
                        onClick={() => setShowDownloadModal(false)}
                        style={{
                          padding: "8px 15px",
                          background: "red",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                      </div>

                  {/* PRINT CSS */}
                  <style>
                    {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
                  </style>
                </div>
              );
            })()}

        </div>
      </div>

    </>
  )
}

export default AMC


const exportInvoiceToExcel = (selectedQuotation) => {
  const items = selectedQuotation.items
    ? JSON.parse(selectedQuotation.items)
    : [];

  const additionalDetails = selectedQuotation.additional_charges
    ? JSON.parse(selectedQuotation.additional_charges)
    : [];

  // ================= HEADER =================
  const headerData = [
    ["STAR SIGNATURE SERVICES"],
    ["A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA BRANCH: DADAR, THANE, PUNE, AURANGABAD, GOA PANJIM"],
    ["Phone: 9209206677 / 9209203355 / 9324004632"],
    ["Email: starsignatureservices@gmail.com"],
    ["GSTIN: 27ADYPY53133M2ZH"],
    [],
    ["AMC Details"],
    [`Party Name: ${selectedQuotation.party_name || "-"}`],
    [`Contact: ${selectedQuotation.party_phone || "-"}`],
    [`Address: ${selectedQuotation.party_address || "-"}`],
    [`Date: ${selectedQuotation.created_date || "-"}`],
    [`Ref Doc: ${selectedQuotation.ref_doc || "-"}`],

    []
  ];

  // ================= ITEMS TABLE =================
  const itemHeader = [["Item Name", "Qty", "Rate", "GST", "Amount"]];
  const itemRows = items.length
    ? items.map(item => [item.name, item.qty, item.rate, item.tax, item.amount])
    : [["No Items Found", "", "", "", ""]];

  // ================= ADDITIONAL DETAILS =================
  const additionalHeader = additionalDetails.length > 0 ? [["Additional Detail", "", "", "", ""]] : [];
  const additionalRows = additionalDetails.map(ad => [ad.type, "", "", ad.value1, ad.value2]);

  // ================= TOTALS =================
  const totals = [
    [],

    ["Grand Total", "", "", "", Number(selectedQuotation.grand_total || 0).toFixed(2)]
  ];

  // ================= REMARK =================
  const remarkSection = selectedQuotation.remark
    ? [["Remark"], [selectedQuotation.remark]]
    : [];

  // ================= FINAL DATA =================
  const finalData = [
    ...headerData,
    ...itemHeader,
    ...itemRows,
    ...additionalHeader,
    ...additionalRows,
    ...totals,
    ...remarkSection
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(finalData);

  // Set column widths
  worksheet["!cols"] = [
    { wch: 40 }, // Full-width for first column
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 15 }
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `AMC_${selectedQuotation.party_name || "Customer"}.xlsx`);
};
